// create
export const CREATE_PAYMENT_VOUCHER_MAINTAIN_REQUEST = "CREATE_PAYMENT_VOUCHER_MAINTAIN_REQUEST";
export const CREATE_PAYMENT_VOUCHER_MAINTAIN_SUCCESS = "CREATE_PAYMENT_VOUCHER_MAINTAIN_SUCCESS";
export const CREATE_PAYMENT_VOUCHER_MAINTAIN_FAIL = "CREATE_PAYMENT_VOUCHER_MAINTAIN_FAIL";

// get
export const PAYMENT_VOUCHER_MAINTAIN_REQUEST = "PAYMENT_VOUCHER_MAINTAIN_REQUEST";
export const PAYMENT_VOUCHER_MAINTAIN_SUCCESS = "PAYMENT_VOUCHER_MAINTAIN_SUCCESS";
export const PAYMENT_VOUCHER_MAINTAIN_FAIL = "PAYMENT_VOUCHER_MAINTAIN_FAIL";

// find
export const FIND_PAYMENT_VOUCHER_MAINTAIN_REQUEST = "FIND_PAYMENT_VOUCHER_MAINTAIN_REQUEST";
export const FIND_PAYMENT_VOUCHER_MAINTAIN_SUCCESS = "FIND_PAYMENT_VOUCHER_MAINTAIN_SUCCESS";
export const FIND_PAYMENT_VOUCHER_MAINTAIN_FAIL = "FIND_PAYMENT_VOUCHER_MAINTAIN_FAIL";

// update
export const UPDATE_PAYMENT_VOUCHER_MAINTAIN_REQUEST = "UPDATE_PAYMENT_VOUCHER_MAINTAIN_REQUEST";
export const UPDATE_PAYMENT_VOUCHER_MAINTAIN_SUCCESS = "UPDATE_PAYMENT_VOUCHER_MAINTAIN_SUCCESS";
export const UPDATE_PAYMENT_VOUCHER_MAINTAIN_FAIL = "UPDATE_PAYMENT_VOUCHER_MAINTAIN_FAIL";

// delete
export const DELETE_PAYMENT_VOUCHER_MAINTAIN_REQUEST = "DELETE_PAYMENT_VOUCHER_MAINTAIN_REQUEST";
export const DELETE_PAYMENT_VOUCHER_MAINTAIN_SUCCESS = "DELETE_PAYMENT_VOUCHER_MAINTAIN_SUCCESS";
export const DELETE_PAYMENT_VOUCHER_MAINTAIN_FAIL = "DELETE_PAYMENT_VOUCHER_MAINTAIN_FAIL";

export const CLEAR_ERROR = "CLEAR_ERROR";
